<template>
    <div class="filters">
        <v-layout row>
            <v-flex md4>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Organization name</span>
                        </div>
                        <v-text-field
                            label="Organization name"
                            placeholder="Organization name"
                            v-model="filters.name"
                            outline
                            single-line
                        ></v-text-field>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md4>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Support email</span>
                        </div>
                        <v-text-field
                            label="Support email"
                            placeholder="Support email"
                            v-model="filters.email"
                            outline
                            single-line
                        ></v-text-field>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md4>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Support phone</span>
                        </div>
                        <v-text-field
                            label="Support phone"
                            placeholder="Support phone"
                            v-model="filters.phone"
                            outline
                            single-line
                        ></v-text-field>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex md4>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Users</span>
                        </div>
                        <user-autocomplete
                            label="Users"
                            placeholder="Users"
                            v-model="filters.users"
                            :multiple="true"
                        ></user-autocomplete>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

import UserAutocomplete from '@/views/Users/components/UserAutocomplete'

export default {
    name: 'OrganizationsFilters',
    components: {
        UserAutocomplete
    },
    props: {
        filters: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.filters {
    .checkbox {
        margin-left: 5px !important;

        ::v-deep .v-input__slot {
            min-height: 0 !important;
            margin-top:12px;
        }
    }
}
</style>
